import { IPostUserData } from '../../types/user';
import { axiosInstance } from '../axiosInstance';

export const getUser = async (token: string | null): Promise<IPostUserData> => {
  const headers: { Authorization?: string } = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await axiosInstance.get(`/users/me`, {
    withCredentials: true,
    headers: headers,
  });
  return response.data;
};
